import * as React from 'react'

import { instantCardApi } from 'redux/services/instant-card'
import {
  GetInstantCardsParams,
  InstantCardObject,
  InstantCardType,
} from 'redux/services/instant-card/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import {
  INSTANT_CARD_REISSUE_TEXT,
  INSTANT_CARD_STATUS_TEXT,
  INSTANT_CARD_TYPE_TEXT,
} from 'constants/instant-card'

import { formatDate } from 'shared/libs'

import { Details } from './components/Details'
import { EmptyDetails } from './components/EmptyDetails'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const InstantCardPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    InstantCardObject['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetInstantCardsParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = instantCardApi.useLazyGetInstantCardsQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetInstantCardsParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="Картоматы"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID',
                  key: 'id',
                },
                {
                  data: 'Название',
                  key: 'device_name',
                },
                {
                  data: 'Тип карты',
                  key: 'type',
                  render: type =>
                    INSTANT_CARD_TYPE_TEXT[type as InstantCardType] || type,
                },
                {
                  data: 'Тип операции',
                  key: 'reissue',
                  render: value => INSTANT_CARD_REISSUE_TEXT[value],
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'ПАН',
                  key: 'pan',
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) => INSTANT_CARD_STATUS_TEXT[item.status],
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
